<template>
    <div class="images">
        <div class="size-container">
            <asset v-for="asset, index in content"
                 :key="asset.id"
                 :asset="asset"
                 :isOpen="isOpen"
                 :assetIndex="`project${liIndex}-asset${index}`"
                 @click="asset.type != 'embed' ? toFront($event.target) : null"></asset>
        </div>
    </div>
</template>

<script>
import { gsap } from "gsap";
import Asset from './Asset.vue'

export default {
  name: 'ImageGallery',
  components: {Asset},
  props: ['content', 'isOpen', 'liIndex'],
  data() {
    return {
      activeTl: null,
    }
  },
  methods: {
    getIntersection(r1, r2) {
        [r1, r2] = [r1, r2].map(r => {
            return {
            x: [r.x1, r.x2].sort((a,b) => a - b),
            y: [r.y1, r.y2].sort((a,b) => a - b)
            };
        });

        const noIntersect = r2.x[0] > r1.x[1] || r2.x[1] < r1.x[0] ||
                            r2.y[0] > r1.y[1] || r2.y[1] < r1.y[0];

        return noIntersect ? false : {
            x1: Math.max(r1.x[0], r2.x[0]), // _[0] is the lesser,
            y1: Math.max(r1.y[0], r2.y[0]), // _[1] is the greater
            x2: Math.min(r1.x[1], r2.x[1]),
            y2: Math.min(r1.y[1], r2.y[1])
        };
    },
    // isOverlapping(div1, div2) {
    //     let rect1 = div1.getBoundingClientRect();
    //     let rect2 = div2.getBoundingClientRect();
    //     return !(
    //             rect1.right < rect2.left ||
    //             rect1.left > rect2.right ||
    //             rect1.bottom < rect2.top ||
    //             rect1.top > rect2.bottom
    //         )
    // },
    getFarthestDistance(target, cards) {
        let tRect = target.getBoundingClientRect();
        let farthestValues = {};
         cards.forEach((card)=>{
            let cRect = card.getBoundingClientRect(card);
            
            if (this.isOverlapping(card, target)) {
                if (!farthestValues.left || cRect.left < farthestValues.left) farthestValues.left = cRect.left
                if (!farthestValues.right || cRect.right > farthestValues.right) farthestValues.right = cRect.right
                if (!farthestValues.top || cRect.top < farthestValues.top) farthestValues.top = cRect.top
                if (!farthestValues.bottom || cRect.bottom > farthestValues.bottom) farthestValues.bottom = cRect.bottom
            }
            
        })
        let distances = {
            left: Math.abs(tRect.right - farthestValues.left),
            right: Math.abs(farthestValues.right - tRect.left),
            top: Math.abs(tRect.bottom - farthestValues.top),
            bottom: farthestValues.bottom - tRect.top
        }
        let minX = distances.left < distances.right ? distances.left*-1 : distances.right;
        let minY = distances.top < distances.bottom ? distances.top*-1 : distances.bottom;
        return {
            x: minX,
            y: minY
        }
    },
    getShortestDistance(target, cards) {
        
        let targetRect = target.getBoundingClientRect(target);
        let shortestDistance = {x: 0, y: 0, moveX: null, moveY: null}

        let intersectingCards = 0;
        //let intersections = []
        
        cards.forEach((card)=>{
            let cardRect = card.getBoundingClientRect(card);
            let rect1 = { x1: cardRect.left, y1: cardRect.top, x2: cardRect.right, y2: cardRect.bottom };
            let rect2 = { x1: targetRect.left, y1: targetRect.top, x2: targetRect.right, y2: targetRect.bottom };
            let intersection = this.getIntersection(rect1, rect2);
            if (intersection){
                // intersection.width = intersection.x2 - intersection.x1;
                // intersection.height = intersection.y2 - intersection.y1;
                // intersections.push(intersection)
                intersectingCards++
                let width = intersection.x2 - intersection.x1;
                let height = intersection.y2 - intersection.y1;
                if (!shortestDistance.x || width < shortestDistance.x) {
                    shortestDistance.x = width + 15;
                    if (cardRect.left < targetRect.left) {shortestDistance.moveX = `+=${width + 15}`} //move right
                    else {shortestDistance.moveX = `-=${width + 15}`} //move left
                }
                if (!shortestDistance.y || height < shortestDistance.y) {
                    shortestDistance.y = height + 15;
                    if (targetRect.top < cardRect.top) { shortestDistance.moveY = `-=${height + 15}`} //move up
                    else { shortestDistance.moveY = `+=${height + 15}`} //move down
                }
            }
            // let cRect = card.getBoundingClientRect(card);
            
            // if (this.isOverlapping(card, target)) {
            //     if (!farthestValues.left || cRect.left < farthestValues.left) farthestValues.left = cRect.left
            //     if (!farthestValues.right || cRect.right > farthestValues.right) farthestValues.right = cRect.right
            //     if (!farthestValues.top || cRect.top < farthestValues.top) farthestValues.top = cRect.top
            //     if (!farthestValues.bottom || cRect.bottom > farthestValues.bottom) farthestValues.bottom = cRect.bottom
            // }
            
        })
        // console.log(intersections)
        
        // intersections.forEach((i)=>{
        //     if (i.width < i.height) {
        //         if (shortestDistance.x <= 0 && i.x1 < shortestDistance.x) shortestDistance.x = targetRect.right + i.x1;
        //         if (shortestDistance.x >= 0 && i.x2 > shortestDistance.x) shortestDistance.x = targetRect.left + i.x2;
                    
        //     } else {
        //         if (shortestDistance.y <= 0 && i.y1 < shortestDistance.y) shortestDistance.y = i.y1;
        //         if (shortestDistance.y >= 0 && i.y2 > shortestDistance.y) shortestDistance.y = i.y2;
        //     }
        // })
        // console.log(shortestDistance)
        
        if (intersectingCards === 1) {
            if (shortestDistance.x > shortestDistance.y) { 
                shortestDistance.x = 0;
                shortestDistance.moveX = "+=0";
            }
            else { 
                shortestDistance.y = 0;
                shortestDistance.moveY = "+=0";
             }
        } 
        return shortestDistance;
        // let distances = {
        //     left: Math.abs(tRect.right - farthestValues.left),
        //     right: Math.abs(farthestValues.right - tRect.left),
        //     top: Math.abs(tRect.bottom - farthestValues.top),
        //     bottom: farthestValues.bottom - tRect.top
        // }
        // let minX = distances.left < distances.right ? distances.left*-1 : distances.right;
        // let minY = distances.top < distances.bottom ? distances.top*-1 : distances.bottom;
        // return {
        //     x: minX,
        //     y: minY
        // }
    },
    toFront(elem) {
        //console.log(elem)
        let target = elem.classList.contains(".image-container") ? elem : elem.closest(".image-container");
        let activeCard = document.querySelector(".image-container.active")
        if (activeCard ) {
            this.activeTl.reverse()
            if(activeCard === target) { return }
        } 
        let cards = document.querySelectorAll('.image-container.active ~ .image-container');
        let shortestDistance = this.getShortestDistance(target, cards);
        let farthestDistance = this.getFarthestDistance(target, cards);
        let moveRatio = shortestDistance.x/shortestDistance.y;
        //let isVert = target.clientWidth <= target.clientHeight || target.clientWidth === target.clientHeight;
        let dimensionsRatio = (target.clientWidth/target.clientHeight);
        //console.log(dimensionsRatio)
        let tl = gsap.timeline({
            onStart: () => {
                document.querySelectorAll("li.active video").forEach((video)=> {video.pause()}) 
            },
            onComplete: ()=> { 
                document.querySelectorAll("li.active .image-container.active video").forEach((video)=> {video.play()}) 
                //elem.focus()
            }, 
            onReverseComplete: ()=> { 
                document.querySelector(".image-container.active").classList.remove("active")
            }
        });
        
        if (moveRatio > 1.5) {
            tl.to(target, {x: shortestDistance.moveX, y: shortestDistance.moveY, onComplete: () => target.parentNode.appendChild(target)})
        } else {
            let animValue = (n, axis)=> {
                if (n < 0) return `-=${Math.abs(farthestDistance[axis] - 15)}`
                else return `+=${farthestDistance[axis] + 15 }`
            }
            if(Math.abs(farthestDistance.x) < Math.abs(farthestDistance.y)) {
                tl.to(target, {x: animValue(farthestDistance.x, "x"), onComplete: () => target.parentNode.appendChild(target)})
            } else {
                tl.to(target, {y: animValue(farthestDistance.y, "y"), onComplete: () => target.parentNode.appendChild(target)})
            }
        }
        tl.to(target, {left: 0, x: dimensionsRatio < .9 ? "50%" : dimensionsRatio < 1.2 ? "25%" : 0, y: "-50%", width: dimensionsRatio < .9 ? "40%" : dimensionsRatio < 1.2 ? "60%" : "80%"})
        
        this.activeTl = tl;
        
    }
  },
}
</script>

<style lang="less">
.has-embed .images {
    margin-left: 0;
    padding-top: 20px;
    .size-container {
        transform: translateZ(0);
    }
}
    .images {
        position: relative;
        width: 50%;
        margin-left: 3%;
        @media (min-width: 1200px) {
            width: 100%;
        }
        .size-container {
           // transform: scale(1.4) translateY(45%) translateZ(0);
            transform-origin: top center;
            height: 100%;
            @media (min-width: 800px) {
                transform: scale(.9) translateX(2.5%) translateZ(0);
                transform-origin: left center;
            }
            @media (min-width: 1200px) {
                transform: scale(1) translateZ(0);
            }
        }
    }
</style>
